import {withProps, setDisplayName, compose} from 'recompose'
import {Field} from 'formik'

export default compose(
  setDisplayName("PreventEnterField"),
  withProps({
    onKeyPress: e => {
      if (e.key === 'Enter') e.preventDefault();
    }
  })
)(Field)